
// Here we're grabbing our global styling from style-components for react.
import { createGlobalStyle } from 'styled-components';

// Here we export it to all the other files AND build it via CSS so we can use these pre-built anywhere.
export const GlobalStyle = createGlobalStyle`

    :root {

        --bg: #080a10;
        --surface: #0d1018;
        --card: #131722;
        --border: #2a3040;
        --borderStrong: #40485c;
        --text: #f2f4ea;
        --textMuted: #a5adbc;
        --textDim: #747d90;
        --ink: #080a10;
        --lime: #b8f23d;
        --limeSurface: #21320b;
        --purple: #8e72ff;
        --purpleSurface: #241d46;
        --purpleText: #b9a9ff;

        --fontHeading: 'Space Grotesk', sans-serif;
        --fontBody: 'Inter', sans-serif;
        --fontMono: 'IBM Plex Mono', monospace;

        --navHeight: 88px;
        --gutter: 72px;
        --maxContentWidth: 1296px;

        /* Legacy tokens, still used by sections that haven't moved to the new design yet. */
        --red: #f10101;
        --blue: #13b3b7;
        --darkBrown: #634430;
        --lightBrown: #916446;
        --darkGray: #252934;
        --white: #fff;
        --black: #000000;
        --transWhite: rgba(255,255,255,0.5);
        --transBlackWeak: rgba(0,0,0,0.3);
        --transBlack: rgba(0,0,0,0.6);
        --transBlackStrong: rgba(0,0,0,0.9);


        --fontMassive: 4rem;
        --fontKindaMassive: 3.5rem;
        --fontSuperBig: 3rem;
        --fontBig: 2.5rem;
        --fontMed: 2rem;
        --fontSmall: 1.5rem;
        --fontTiny: 1.25rem;

        --fontReg: 'Inter', sans-serif;
        
        --fontWeightThin: 100;
        --fontWeightReg: 400;
        --fontWeightBold: 700;
        
        --textShadowBasic: 4px 4px 4px rgba(0,0,0,0.5);
        --boxShadowBasic: 4px 4px 8px 2px rgba(0,0,0,0.5);
        --boxShadowStrong: 0px 0px 12px 6px rgba(0,0,0,0.5);

    }

    @media (max-width: 768px) {
        :root {
            --navHeight: 68px;
            --gutter: 24px;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        *,
        *::before,
        *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
        }
    }
`;
